import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './components.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../config/api';

const Footer = () => {
  const navigate = useNavigate();
  const [storeSettings, setStoreSettings] = useState({
    storeAddress: '123 Food Street, Lagos',
    storePhone: '+234 812 345 6789',
    storeEmail: 'hello@noureeshfoods.com',
    openingTime: '9:00 AM',
    closingTime: '9:00 PM'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStoreSettings = async () => {
      try {
  const response = await axios.get(`${API}/settings`);
        if (response.data && response.data.store) {
          const { storeAddress, storePhone, storeEmail, openingTime, closingTime } = response.data.store;
          setStoreSettings({
            storeAddress: storeAddress || '123 Food Street, Lagos',
            storePhone: storePhone || '+234 700 NOUREESH',
            storeEmail: storeEmail || 'hello@noureeshfoods.com',
            openingTime: openingTime ? formatTime(openingTime) : '9:00 AM',
            closingTime: closingTime ? formatTime(closingTime) : '9:00 PM'
          });
        }
      } catch (error) {
        console.error('Error fetching store settings:', error);
        // Keep default values if API call fails
      } finally {
        setLoading(false);
      }
    };

    const formatTime = (timeString) => {
      if (!timeString) return '9:00 AM';
      
      try {
        const [hours, minutes] = timeString.split(':');
        const hourInt = parseInt(hours, 10);
        const period = hourInt >= 12 ? 'PM' : 'AM';
        const hour12 = hourInt % 12 || 12; // Convert 0 or 24 to 12
        return `${hour12}:${minutes || '00'} ${period}`;
      } catch (error) {
        console.error('Error formatting time:', error);
        return '9:00 AM';
      }
    };

    fetchStoreSettings();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  if (loading) {
    return (
      <footer className="bg-dark text-white py-4 text-center mt-auto">
        <Container>
          <div className="text-center py-2">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </footer>
    );
  }

  return (
    <footer className="bg-dark text-white py-4 text-center mt-auto">
      <Container>
        <Row>
          {/* About Column */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5>Noureesh Foods</h5>
            <p className="text-white">Delivering deliciousness to your doorstep since 2024.</p>
            <div className="social-icons d-flex align-items-center justify-content-center gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white facebook-icon-link" aria-label="Facebook">
                <i className="bi bi-facebook facebook-icon" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white instagram-icon-link" aria-label="Instagram">
                <i className="bi bi-instagram instagram-icon" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-white youtube-icon-link" aria-label="Youtube">
                <i className="bi bi-youtube youtube-icon" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white twitter-icon-link" aria-label="Twitter">
                <i className="bi bi-twitter-x twitter-icon" style={{ fontSize: '1.5rem' }}></i>
              </a>
            </div>
          </Col>

          {/* Quick Links Column */}
          <Col md={2} className="mb-4 mb-md-0">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <span onClick={() => handleNavigation('/')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Home
                </span>
              </li>
              <li className="mb-2">
                <span onClick={() => handleNavigation('/menu')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Menu
                </span>
              </li>
              <li className="mb-2">
                <span onClick={() => handleNavigation('/about')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  About Us
                </span>
              </li>
              <li className="mb-2">
                <span onClick={() => handleNavigation('/contact')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Contact
                </span>
              </li>
              <li className="mb-2">
                <span onClick={() => handleNavigation('/admin-login')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Admin
                </span>
              </li>
              <li>
                <span onClick={() => handleNavigation('/cart')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Cart
                </span>
              </li>
            </ul>
          </Col>

          {/* Categories Column */}
          <Col md={2} className="mb-4 mb-md-0">
            <h5>Categories</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <span onClick={() => handleNavigation('/menu')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Cakes
                </span>
              </li>
              <li className="mb-2">
                <span onClick={() => handleNavigation('/menu')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Cookies
                </span>
              </li>
              <li className="mb-2">
                <span onClick={() => handleNavigation('/menu')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Desserts
                </span>
              </li>
              <li className="mb-2">
                <span onClick={() => handleNavigation('/menu')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Rice Dishes
                </span>
              </li>
              <li>
                <span onClick={() => handleNavigation('/custom-order')} className="text-white nav-link-custom" style={{ cursor: 'pointer' }}>
                  Custom Order
                </span>
              </li>
            </ul>
          </Col>

          {/* Contact Column */}
          <Col md={4}>
            <h5>Contact Us</h5>
            <ul className="list-unstyled text-white">
              <li className="mb-2"><FontAwesomeIcon icon={faMapMarkerAlt} className="me-2"/> {storeSettings.storeAddress}</li>
              <li className="mb-2"><FontAwesomeIcon icon={faPhone} className="me-2"/> {storeSettings.storePhone}</li>
              <li className="mb-2"><FontAwesomeIcon icon={faEnvelope} className="me-2"/> {storeSettings.storeEmail}</li>
              <li><FontAwesomeIcon icon={faClock} className="me-2"/> {storeSettings.openingTime} - {storeSettings.closingTime} Daily</li>
            </ul>
          </Col>
        </Row>
        <hr className="my-4"/>
        <Row>
          <Col className="text-center">
            <p className="mb-0 small">
              &copy; {new Date().getFullYear()} Noureesh Foods. All rights reserved. | 
              <span onClick={() => handleNavigation('/privacy-policy')} className="text-white ms-2 nav-link-custom" style={{ cursor: 'pointer' }}>
                Privacy Policy
              </span> | 
              <span onClick={() => handleNavigation('/terms-of-service')} className="text-white ms-2 nav-link-custom" style={{ cursor: 'pointer' }}>
                Terms of Service
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;